import moment from 'moment';
import { getErrorMessage } from '../util/ErrorUtils';
import axios from '../util/axiosConfig';


export const patientSearchOldAPI = async (payload) => {
    return await axios.get(`/api/v1/patients/search`, {
        params: {
            ...payload
        }
    }).then(function (response) {
        if (response.data) {
            return { success: true, data: response.data };
        } else {
            return { success: false };
        }
    })
        .catch(function (error) {
            return { success: false, error };
        });
}

export const patientSearchAPI = async (data) => {
    let url = `/api/v1/patients/search-advanced`;
    if (data?.dob) url = `/api/v1/patients/search-advanced?dob=${data?.dob}`;
    if (data?.key) url += `${data?.dob ? '&' : '?'}key=${data?.key}`;

    return await axios.get(url).then(function (response) {
        if (response.data) {
            return { success: true, data: response.data };
        } else {
            return { success: false };
        }
    })
        .catch(function (error) {
            return { success: false, error };
        });
}

export const getAppointments = async (payload) => {

    return await axios.get(`/api/v1/receptionist/appointments`, {
        params: {
            ...payload
        }
    }).then(function (response) {
        if (response.data) {
            return { success: true, appointments: response.data };
        } else {
            return { success: false };
        }
    })
        .catch(function (error) {
            return { success: false, error };
        });
}

export const addUpdateAppointmentDB = async (appointment) => {
    return await axios.post(`/api/v1/receptionist/add-update-appointment`, appointment)
        .then(function (response) {
            if (response.data) {
                return { success: true, appointment: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}

export const addUpdateAppointmentEventDB = async (event) => {
    return await axios.post(`/api/v1/receptionist/add-update-appointment-event`, event)
        .then(function (response) {
            if (response.data) {
                return { success: true, event: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}

export const fetchResourceAvailabilityRosterAPI = async ({ practiceId, startDate, endDate }) => {
    return await axios.get(`/api/v1/practice/${practiceId}/rosters`, {
        params: {
            "startDate": startDate,
            "endDate": endDate
        }
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}

export const cancelAppointmentEventAPI = async ({ appointmentId, eventId }) => {
    return await axios.get(`/api/v1/receptionist/cancel-appointment-event`,
        {
            params: {
                appointmentId: appointmentId,
                eventId: eventId,
            }
        },
    ).then(function (response) {
        if (response.data) {
            return { success: true, data: response.data };
        } else {
            return { success: false };
        }
    })
        .catch(function (error) {
            return { success: false };
        });
}

export const cancelAppointmentAPI = async (appointmentId) => {
    return await axios.get(`/api/v1/receptionist/appointments/${appointmentId}/cancel-appointment`, {
        params: {
            appointmentId
        }
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        })
}

export const getReferralDocumentsAPI = async (appointmentId) => {

    return await axios.get(`/api/v1/appointment-documents`, {
        params: {
            "appointmentId": appointmentId
        }
    }).then(function (response) {

        if (response.data) {
            return { success: true, data: response.data };
        } else {
            return { success: false };
        }
    })
        .catch(function (error) {
            return { success: false };
        });
}

export const fetchAppointmentsByMipAPI = async (payload) => {
    const data = {
        ...payload,
        page: payload.page - 1,
        status: payload.status === undefined ? '' : payload.status
    };
    return await axios.post(`/api/v1/receptionist/page-appointments`, data).then(function (response) {
        if (response.data) {
            return { success: true, data: response.data };
        } else {
            return { success: false };
        }
    })
        .catch(function (error) {
            return { success: false, error };
        });
}

export const sendSMSNotificationAPI = async (payload) => {
    return await axios.post(`/api/v1/tnz/send/sms`, payload)
        .then(function (response) {
            if (response.data) {
                return { success: true, appointment: response.data };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error };
        });
}

export const deleteAppointmentDocument = async (documentId) => {
    return await axios.delete(`/api/v1/appointment-document`, {
        params: {
            documentId
        }
    }).then(function (response) {
        if (response.data) {
            return { success: true, data: response.data };
        } else {
            return { success: false }
        }
    }).catch(function (error) {
        return { success: false, error }
    })
}



export const checkSlotAvailabilityAPI = async (eventData) => {
    return await axios.post(`/api/v1/receptionist/check-slot-availability`, eventData)
        .then(response => ({ success: true, data: response.data }))
        .catch(error => ({ success: false, error: getErrorMessage(error) }));
};

export const markAsAbsentAPI = async (appointmentId) => {
    return await axios.put(`/api/v1/receptionist/appointments/${appointmentId}/mark-absent`)
        .then(res => ({ success: true, data: res.data }))
        .catch(err => ({ success: false, error: err }));
};

export const confirmManualAPI = async (appointmentId) => {
    return await axios.put(`/api/v1/receptionist/appointments/${appointmentId}/confirm-manual`)
        .then(res => ({ success: true, data: res.data }))
        .catch(err => ({ success: false, error: err }));
};

export const downloadAppointmentConfirmationAPI = async (payload) => {
    return await axios.post(`/api/v1/receptionist/appointment-confirm-letter`, payload, { responseType: 'blob' })
        .then(function (response) {
            if (response.data) {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                let fileName = `APTCNF_${payload?.appointmentId}_${payload?.eventId}` + '.pdf';
                link.setAttribute('download', fileName); //or any other extension
                document.body.appendChild(link);
                link.click();
                return { success: true };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: error };
        });
}

export const printAppointmentConfirmationAPI = async (payload) => {
    return await axios.post(`/api/v1/receptionist/appointment-confirm-letter`, payload, { responseType: 'blob' })
        .then(function (response) {
            if (response.data) {
                const blob = new Blob([response.data], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                const iframe = document.createElement('iframe');
                iframe.style.display = 'none';
                iframe.src = url;
                document.body.appendChild(iframe);
                iframe.onload = function () {
                    iframe.contentWindow.focus();
                    iframe.contentWindow.print();
                    setTimeout(() => {
                        document.body.removeChild(iframe);
                        window.URL.revokeObjectURL(url);
                    }, 1000);
                };
                return { success: true };
            } else {
                return { success: false };
            }
        })
        .catch(function (error) {
            return { success: false, error: error };
        });
}